/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import PaymentService from '../../services/PaymentService';
import PaymentTypes from '../types/PaymentTypes';
import toFormikErrors from '../../utils/ApiErrors';

//* get all payment list items
function getAll(pageOption, sortData, department, client, status, searchWord, rangeDate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_LIST_REQUEST });
    try {
      const res = await PaymentService.getAll(
        pageOption,
        sortData,
        department,
        client,
        status,
        searchWord,
        rangeDate
      );
      dispatch({
        type: PaymentTypes.GET_PAYMENT_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

function add(postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.ADD_PAYMENT_REQUEST });
    try {
      const res = await PaymentService.add(postData);
      dispatch({ type: PaymentTypes.ADD_PAYMENT_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        // toast.success(res.data.message);
      }
      if (res?.data && res?.data?.data && res?.data?.data?.id) {
        console.log(res.data.data.id, 'res.data.data.id');
        const previewCode = 'payment-request/preview';
        navigate(`/${previewCode}/${res.data.data.id}`);
      }
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.ADD_PAYMENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_ITEM_REQUEST });
    try {
      const res = await PaymentService.getItem(code);
      dispatch({
        type: PaymentTypes.GET_PAYMENT_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.UPDATE_PAYMENT_REQUEST });
    try {
      const res = await PaymentService.update(code, postData);
      dispatch({
        type: PaymentTypes.UPDATE_PAYMENT_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      // setTimeout(() => dispatch(PaymentAction.getAll()), 500);
      submitting(false);
      const previewCode = 'payment-request/preview';
      navigate(`/${previewCode}/${code}`);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.UPDATE_PAYMENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function updatePreview(code, postData, setErrors, submitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.UPDATE_PREVIEW_PAYMENT_REQUEST });
    try {
      const res = await PaymentService.updatePreview(code, postData);
      dispatch({
        type: PaymentTypes.UPDATE_PREVIEW_PAYMENT_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      navigate(`/payment-request/view/${code}`);
      setTimeout(() => dispatch(PaymentAction.getItem(code)), 500);
      submitting(false);
      // navigate(`/payment-request/preview/code`);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.UPDATE_PAYMENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.DELETE_PAYMENT_REQUEST });
    try {
      const res = await PaymentService.deleteItem(code);
      dispatch({
        type: PaymentTypes.DELETE_PAYMENT_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(PaymentAction.getAll()), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.DELETE_PAYMENT_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getPaymentFilter() {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_INVOICE_FILTER_REQUEST });
    try {
      const res = await PaymentService.getPaymentFilter();
      dispatch({
        type: PaymentTypes.GET_INVOICE_FILTER_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_INVOICE_FILTER_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getInvoiceNumber(officeId = null) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_INVOICE_NUMBER_REQUEST });

    try {
      const res = await PaymentService.getInvoiceNumber(officeId);

      dispatch({
        type: PaymentTypes.GET_INVOICE_NUMBER_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || 'Failed to fetch invoice number';
      dispatch({
        type: PaymentTypes.GET_INVOICE_NUMBER_ERROR,
        error: message
      });

      // Optional: Show toast notification
      // toast.error(message);
    }
  };
}

function getPaymentMethod() {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_METHOD_REQUEST });
    try {
      const res = await PaymentService.getPaymentMethod();
      dispatch({
        type: PaymentTypes.GET_PAYMENT_METHOD_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_METHOD_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getPaymentType() {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_REQUEST_TYPE_REQUEST });
    try {
      const res = await PaymentService.getPaymentType();
      dispatch({
        type: PaymentTypes.GET_PAYMENT_REQUEST_TYPE_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_REQUEST_TYPE_ERROR,
          error: error.response
        });
      }
    }
  };
}

function resendInvoice(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_RESEND_REQUEST });
    try {
      const res = await PaymentService.resendInvoice(code);
      dispatch({
        type: PaymentTypes.GET_PAYMENT_RESEND_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_RESEND_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function reminderInvoice(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_REMINDER_REQUEST });
    try {
      const res = await PaymentService.reminderInvoice(code);
      dispatch({
        type: PaymentTypes.GET_PAYMENT_REMINDER_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_REMINDER_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function copyInvoice(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_COPY_REQUEST });
    try {
      const res = await PaymentService.copyInvoice(code);
      dispatch({
        type: PaymentTypes.GET_PAYMENT_COPY_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      closeModal();
      setTimeout(() => dispatch(PaymentAction.getAll()), 500);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_COPY_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getAllTransaction(pageOption, sort, method, type, status, keyword, rangeDate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_ALL_TRANSACTION_REQUEST });
    try {
      const res = await PaymentService.getAllTransaction(
        pageOption,
        sort,
        method,
        type,
        status,
        keyword,
        rangeDate
      );
      dispatch({
        type: PaymentTypes.GET_ALL_TRANSACTION_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_ALL_TRANSACTION_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getTransactionItem(code) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_TRANSACTION_ITEM_REQUEST });
    try {
      const res = await PaymentService.getTransactionItem(code);
      dispatch({
        type: PaymentTypes.GET_TRANSACTION_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_TRANSACTION_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}
function getTransactionStatus() {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_TRANSACTION_STATUS_REQUEST });
    try {
      const res = await PaymentService.getTransactionStatus();
      dispatch({
        type: PaymentTypes.GET_TRANSACTION_STATUS_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_TRANSACTION_STATUS_ERROR,
          error: error.response
        });
      }
    }
  };
}

// Testing aid: mail the currently previewed design to an arbitrary address.
function sendPreviewMail(code, postData, setSending) {
  return async () => {
    setSending(true);
    try {
      const res = await PaymentService.sendPreviewMail(code, postData);
      toast.success(res?.data?.message || 'Test mail sent');
    } catch (error) {
      const data = error?.response?.data;
      toast.error(data?.errors?.email || data?.message || 'Could not send the test mail');
    } finally {
      setSending(false);
    }
  };
}

function previewMail(code, postData, setDrawerOpen, setMailContentValue, setPdfUrl) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.PREVIEW_MAIL_REQUEST });
    try {
      const res = await PaymentService.previewMail(code, postData);
      dispatch({ type: PaymentTypes.PREVIEW_MAIL_SUCCESS, payload: res.data });
      // if (res.data && res.data.message) {
      //   toast.success(res.data.message);
      // }
      if (res.data && res.data.data) {
        if (res.data.data?.template) {
          setMailContentValue(res.data.data.template);
        }
        // Download link for the generated invoice PDF; null until one exists.
        if (setPdfUrl) {
          setPdfUrl(res.data.data?.pdf_url || '');
        }
      }
      setDrawerOpen(true);
      // setTimeout(() => dispatch(PaymentAction.getItem(code)), 500);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.PREVIEW_MAIL_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getPaymentDatails(code, token, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_DETAILS_REQUEST });
    try {
      const res = await PaymentService.getPaymentDatails(code, token);
      dispatch({
        type: PaymentTypes.GET_PAYMENT_DETAILS_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_DETAILS_ERROR,
          error: error.response
        });
        if (
          error.response.status === 400 ||
          error.response.status === 404 ||
          error.response.status === 422
        ) {
          navigate('/payment-link-exprie');
        }
      }
    }
  };
}

function generatePaypal(code, setLoading) {
  return async (dispatch) => {
    setLoading(true);
    dispatch({ type: PaymentTypes.GET_GENERATE_PAYPAL_REQUEST });
    try {
      const res = await PaymentService.generatePaypal(code);
      dispatch({
        type: PaymentTypes.GET_GENERATE_PAYPAL_SUCCESS,
        payload: res.data.data
      });

      if (res && res?.data && res?.data?.data) {
        if (res?.data?.data?.link) {
          console.log(res.data.data.link);
          setTimeout(() => {
            window.location.href = res.data.data.link;
            // setLoading(false);
          }, 1000);
        }
      }
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_GENERATE_PAYPAL_ERROR,
          error: error.response
        });
        setLoading(false);
      }
    }
  };
}

function paypalSuccess(code, payerId, invoiceCode) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYPAL_SUCCESS_REQUEST });
    try {
      const res = await PaymentService.paypalSuccess(code, payerId, invoiceCode);
      dispatch({
        type: PaymentTypes.GET_PAYPAL_SUCCESS_SUCCESS,
        payload: res.data.data
      });
      return res.data.data;
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYPAL_SUCCESS_ERROR,
          error: error.response
        });
      }
      throw error;
    }
    // no need for "return null" here since all paths above return/throw
  };
}

function paypalCancel(code) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYPAL_CANCEL_REQUEST });
    try {
      const res = await PaymentService.paypalCancel(code);
      dispatch({
        type: PaymentTypes.GET_PAYPAL_CANCEL_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYPAL_CANCEL_ERROR,
          error: error.response
        });
      }
    }
  };
}

function generateVeem(code, setLoading) {
  return async (dispatch) => {
    setLoading(true);
    dispatch({ type: PaymentTypes.GET_GENERATE_VEEM_REQUEST });
    try {
      const res = await PaymentService.generateVeem(code);
      dispatch({
        type: PaymentTypes.GET_GENERATE_VEEM_SUCCESS,
        payload: res.data.data
      });

      if (res && res?.data && res?.data?.data) {
        if (res?.data?.data?.link) {
          console.log(res.data.data.link);
          setTimeout(() => {
            window.location.href = res.data.data.link;
          }, 1000);
        }
      }
      setLoading(false);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_GENERATE_VEEM_ERROR,
          error: error.response
        });
        setLoading(false);
      }
    }
  };
}

function updateAuthorizeNet(code, postData, setErrors, setSubmitting, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.UPDATE_AUTHORIZENET_CARD_REQUEST });
    try {
      const res = await PaymentService.updateAuthorizeNet(code, postData);
      dispatch({ type: PaymentTypes.UPDATE_AUTHORIZENET_CARD_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
        navigate(`/payment/success/${code}`);
      }
      // setTimeout(() => dispatch(PaymentAction.getItem(code)), 500);
      setSubmitting(false);
    } catch (error) {
      if (error && error.response) {
        setSubmitting(false);
        dispatch({
          type: PaymentTypes.UPDATE_AUTHORIZENET_CARD_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function updateStripe(
  code,
  postData,
  setErrors,
  setSubmitting,
  setClientSecretID,
  confirmPaymentStripe
) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.UPDATE_STRIPE_CREATE_REQUEST });
    try {
      const res = await PaymentService.updateStripe(code, postData);
      dispatch({ type: PaymentTypes.UPDATE_STRIPE_CREATE_SUCCESS, payload: res.data });
      // if (res.data && res.data.message) {
      //   toast.success(res.data.message);
      // }
      if (res.data && res.data.clientSecret) {
        setClientSecretID(res.data.clientSecret);
        setTimeout(() => {
          confirmPaymentStripe(res.data.clientSecret, setSubmitting);
        }, 500);
      }
      // ispatch(PaymentAction.getItem(code)
      // setSubmitting(false);
    } catch (error) {
      if (error && error.response) {
        setSubmitting(false);
        dispatch({
          type: PaymentTypes.UPDATE_STRIPE_CREATE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function updateStripeCapture(code, postData, navigate, setSubmitting) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.UPDATE_STRIPE_CAPTURE_REQUEST });
    try {
      const res = await PaymentService.updateStripeCapture(postData);
      dispatch({ type: PaymentTypes.UPDATE_STRIPE_CAPTURE_SUCCESS, payload: res.data });
      // if (res.data && res.data.message) {
      //   toast.success(res.data.message);
      // }
      navigate(`/payment/success/${code}`);
      setSubmitting(false);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.UPDATE_STRIPE_CAPTURE_ERROR,
          error: error.response
        });
        setSubmitting(false);
        navigate('/payment/fail');
      }
    }
  };
}

function getPendingPayment(code, setPendingModal) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_PENDING_ITEM_REQUEST });
    try {
      const res = await PaymentService.getPendingPayment(code);
      dispatch({
        type: PaymentTypes.GET_PAYMENT_PENDING_ITEM_SUCCESS,
        payload: res.data.data
      });
      if (res && res.data && res.data.data) {
        console.log(res.data.data);
        setPendingModal(true);
      }
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_PAYMENT_PENDING_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getAllManualPayment(pageOption, sort, method, type, keyword, rangeDate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_MANUAL_PAYMENT_LIST_REQUEST });
    try {
      const res = await PaymentService.getAllManualPayment(
        pageOption,
        sort,
        method,
        type,
        keyword,
        rangeDate
      );
      dispatch({
        type: PaymentTypes.GET_MANUAL_PAYMENT_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_MANUAL_PAYMENT_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

const updateManualQueryParams = (paging, sorting, method, type, keyword, rangeDate) => ({
  type: PaymentTypes.UPDATE_MANUAL_QUERY_PARAMS,
  payload: { paging, sorting, method, type, keyword, rangeDate }
});

function addManualPayment(code, postData, type, setErrors, submitting, closeModal) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.ADD_MANUAL_PAYMENT_REQUEST });
    try {
      const res = await PaymentService.addManualPayment(code, type, postData);
      dispatch({ type: PaymentTypes.ADD_MANUAL_PAYMENT_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(PaymentAction.getItem(code)), 500);
      closeModal();
      submitting(false);
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.ADD_MANUAL_PAYMENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function getManualPaymentItem(code) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_MANUAL_PAYMENT_ITEM_REQUEST });
    try {
      const res = await PaymentService.getManualPaymentItem(code);
      dispatch({
        type: PaymentTypes.GET_MANUAL_PAYMENT_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_MANUAL_PAYMENT_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateManualPayment(code, postData, setErrors, submitting, closeModal, reasonModal) {
  return async (dispatch, getState) => {
    dispatch({ type: PaymentTypes.UPDATE_MANUAL_PAYMENT_REQUEST });
    try {
      const res = await PaymentService.updateManualPayment(code, postData);
      dispatch({
        type: PaymentTypes.UPDATE_MANUAL_PAYMENT_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      closeModal();
      if (reasonModal) {
        reasonModal();
      }
      const { paginationData, sortingData, payMethod, payType, keyword, rangeDateData } =
        getState().payment.manualQueryParams;
      setTimeout(
        () =>
          dispatch(
            PaymentAction.getAllManualPayment(
              paginationData,
              sortingData,
              payMethod,
              payType,
              keyword,
              rangeDateData
            )
          ),
        500
      );
      submitting(false);
    } catch (error) {
      if (error && error.response) {
        console.log(error, 'error');
        dispatch({
          type: PaymentTypes.UPDATE_MANUAL_PAYMENT_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function getManualPaymentFilter() {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_MANUAL_PAYMENT_FILTER_REQUEST });
    try {
      const res = await PaymentService.getManualPaymentFilter();
      dispatch({
        type: PaymentTypes.GET_MANUAL_PAYMENT_FILTER_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.GET_MANUAL_PAYMENT_FILTER_ERROR,
          error: error.response
        });
      }
    }
  };
}

function deleteTimeSheet(code) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.DELETE_TIMESHEET_REQUEST });
    try {
      const res = await PaymentService.deleteTimeSheet(code);
      dispatch({
        type: PaymentTypes.DELETE_TIMESHEET_SUCCESS,
        payload: res.data.data
      });
      // if (res.data && res.data.message) {
      //   toast.success(res.data.message);
      // }
      // setTimeout(() => dispatch(PaymentAction.getAll()), 500);
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: PaymentTypes.DELETE_TIMESHEET_ERROR,
          error: error.response
        });
      }
    }
  };
}

function updateCloverCharge(code, postData, setErrors, setLoading, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.UPDATE_CLOVER_CHARGE_REQUEST });
    try {
      const res = await PaymentService.updateCloverCharge(code, postData);
      dispatch({ type: PaymentTypes.UPDATE_CLOVER_CHARGE_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
        navigate(`/payment/success/${code}`);
      }
      // setTimeout(() => dispatch(PaymentAction.getItem(code)), 500);
      setLoading(false);
    } catch (error) {
      if (error && error.response) {
        setLoading(false);
        dispatch({
          type: PaymentTypes.UPDATE_CLOVER_CHARGE_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(toFormikErrors(error.response.data.errors));
          }
        }
      }
    }
  };
}

function getPaymentStatus(code, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_PAYMENT_STATUS_REQUEST });
    try {
      const res = await PaymentService.getPaymentStatus(code);
      dispatch({
        type: PaymentTypes.GET_PAYMENT_STATUS_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        navigate('/payment-link-exprie');
        dispatch({
          type: PaymentTypes.GET_PAYMENT_STATUS_ERROR,
          error: error.response
        });
      }
    }
  };
}

function getScheduleCancel(code, navigate) {
  return async (dispatch) => {
    dispatch({ type: PaymentTypes.GET_SCHEDULE_CANCEL_REQUEST });
    try {
      const res = await PaymentService.getScheduleCancel(code);
      if (res?.data?.message) {
        toast.success(res.data.message);
        navigate(`/payment-request/preview/${code}`);
      }
      dispatch({
        type: PaymentTypes.GET_SCHEDULE_CANCEL_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        // if (error?.response?.data?.message) {
        //   toast.error(error.response.data.message);
        // }
        dispatch({
          type: PaymentTypes.GET_SCHEDULE_CANCEL_ERROR,
          error: error.response
        });
      }
    }
  };
}

const PaymentAction = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getInvoiceNumber,
  getPaymentMethod,
  getPaymentType,
  updatePreview,
  reminderInvoice,
  resendInvoice,
  copyInvoice,
  getAllTransaction,
  getTransactionItem,
  getTransactionStatus,
  previewMail,
  sendPreviewMail,
  getPaymentDatails,
  generatePaypal,
  updateAuthorizeNet,
  updateStripe,
  updateStripeCapture,
  paypalCancel,
  paypalSuccess,
  getPendingPayment,
  getAllManualPayment,
  updateManualQueryParams,
  addManualPayment,
  updateManualPayment,
  getManualPaymentItem,
  getManualPaymentFilter,
  deleteTimeSheet,
  getPaymentFilter,
  generateVeem,
  updateCloverCharge,
  getPaymentStatus,
  getScheduleCancel
};

export default PaymentAction;
